module.exports = __webpack_public_path__ + "media/Joker.5385c048.mp3";